export const STOCKS_IN_REQUEST_PERMISSION = Object.freeze({
  VIEW: 'ST_STOCKSINREQUEST_VIEW',
  EDIT: 'ST_STOCKSINREQUEST_EDIT',
  OPENING_DATE_EDIT: 'ST_STOCKSINREQUEST_OPENING_DATE_EDIT',
  IMPORT: 'ST_STOCKSINREQUEST_IMPORT',
  EDIT_IMPORTED: 'ST_STOCKSINREQUEST_EDIT_IMPORTED',
  IMEI_CORRECT: 'ST_STOCKSINREQUEST_IMEI_CORRECT',
  COST_CORRECT: 'ST_STOCKSINREQUEST_COST_CORRECT',
  HISTORY_VIEW: 'ST_STOCKSINREQUEST_HISTORY_VIEW',
});

export const POST_IMPORT_ROUTE_PERMISSIONS = [
  STOCKS_IN_REQUEST_PERMISSION.EDIT,
  STOCKS_IN_REQUEST_PERMISSION.IMPORT,
  STOCKS_IN_REQUEST_PERMISSION.EDIT_IMPORTED,
  STOCKS_IN_REQUEST_PERMISSION.IMEI_CORRECT,
  STOCKS_IN_REQUEST_PERMISSION.COST_CORRECT,
];
